import { assert, subTestContext, Test } from "oc-e2e-testrunner";
import {
  assertSegmentIstLückenlosGefüllt,
  createMauer,
  getIstSollZwischenabstandVerbose,
  logParts,
  resetArrangement,
} from "./utils";
import { v3 } from "oc-threejs/short3";
import { getElementAnzahlDieInsEmptyPasst } from "../arrangement/elementFunctions";
import { changeStreckenLaenge } from "../arrangement/grundrissFunctions";

export default {
  name: "TestStreckeFillWithElements",
};

export const testLeerbreiten: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const grundriss = agt.grundriss;
  grundriss.setStandardForm("Strecke", [1]);
  agt.segmente[0].parts = [];
  const breiten = [..._.range(0.2, 3, 0.2), 5, 10, 15, 20, 30, 100];
  for (const breite of breiten) {
    await subTestContext("Test Leerbreite " + breite + ": ", async () => {
      grundriss.setStandardForm("Strecke");
      changeStreckenLaenge(
        grundriss.kanten,
        grundriss.kantenIdToChangeCount,
        grundriss.kanten[0].id,
        breite
      );
      agt.segmente[0].parts = [];
      agt.update3d();
      const s = agt.segmente[0];
      assert.equals(breite, s.breite);
      assert.equals(0, s.parts.length);
      assert.equals(0, s.pfosten.length);
    });
  }
};

export const test1mBis10mGrob: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  _.range(1, 10, 0.6).forEach((breite) => {
    agt.grundriss.setStandardForm("Strecke", [breite]);
    agt.segmente[0].parts = [];
    agt.fillIndividuellSegmentsWithElements();
    const s = agt.segmente[0];
    assertSegmentIstLückenlosGefüllt(s);
  });
};

export const testSollPfostenDelta1m: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [1]);
  agt.update3d();
  const empty = agt.segmente[0].empties[0];
  const element = agt.createDefaultElement();
  const delta = getIstSollZwischenabstandVerbose(empty, element);
  assert.deepEquals(
    {
      linksIst: {
        richtung: "Links",
        zwischenabstand: 0,
        gap: 0,
        umprofilBreite: 0,
        gapLinks: 0,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0,
        umprofilBreiteRechts: 0,
        gapRechts: 0,
        segmentEndenAusgleich: 0,
        eckadapterDelta: 0,
      },
      linksSoll: {
        richtung: "Links",
        zwischenabstand: 0.02,
        gap: -0.02,
        umprofilBreite: 0,
        gapLinks: 0,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0.08,
        umprofilBreiteRechts: 0,
        gapRechts: -0.02,
        segmentEndenAusgleich: -0.04,
        eckadapterDelta: 0,
      },
      rechtsIst: {
        richtung: "Rechts",
        zwischenabstand: 0,
        gap: 0,
        umprofilBreite: 0,
        gapLinks: 0,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0,
        umprofilBreiteRechts: 0,
        gapRechts: 0,
        segmentEndenAusgleich: 0,
        eckadapterDelta: 0,
      },
      rechtsSoll: {
        richtung: "Rechts",
        zwischenabstand: 0.02,
        gap: -0.02,
        umprofilBreite: 0,
        gapLinks: -0.02,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0.08,
        umprofilBreiteRechts: 0,
        gapRechts: 0,
        segmentEndenAusgleich: -0.04,
        eckadapterDelta: 0,
      },
    },
    delta
  );
};

export const test190cm: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [1]);
  agt.segmente[0].parts = [];
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  assert.equals(1, s.getElemente().length);
  assertSegmentIstLückenlosGefüllt(s);
};

export const test372cm: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.segmente[0].parts = [];
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  assert.equals(2, s.getElemente().length);
  assertSegmentIstLückenlosGefüllt(s);
};

export const test1m: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [1]);
  agt.segmente[0].parts = [];
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  assertSegmentIstLückenlosGefüllt(s);
  const parts = s.getPartsAndPfosten();
  const json = logParts(s, parts);
  assert.deepEquals(
    [
      {
        x0: -0.04,
        x1: 0.04,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 0,
        breite: 0.08,
        lichteWeite: 0,
        ecke: true,
      },
      {
        x0: 0.02,
        x1: 0.98,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 0.96,
        lichteWeite: 0.92,
        ecke: false,
      },
      {
        x0: 0.96,
        x1: 1.04,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 0,
        breite: 0.08,
        lichteWeite: 0,
        ecke: true,
      },
    ],
    json
  );
};

export const test220cm: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.segmente[0].parts = [];
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  assertSegmentIstLückenlosGefüllt(s);
};

export const test2m: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [2]);
  agt.segmente[0].parts = [];
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  assertSegmentIstLückenlosGefüllt(s);
  const parts = s.getPartsAndPfosten();
  const json = logParts(s, parts);
  assert.deepEquals(
    [
      {
        x0: -0.04,
        x1: 0.04,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 0,
        breite: 0.08,
        lichteWeite: 0,
        ecke: true,
      },
      {
        x0: 0.02,
        x1: 0.98,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 0.96,
        lichteWeite: 0.92,
        ecke: false,
      },
      {
        x0: 0.96,
        x1: 1.04,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 1.02,
        x1: 1.98,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 0.96,
        lichteWeite: 0.92,
        ecke: false,
      },
      {
        x0: 1.96,
        x1: 2.04,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 0,
        breite: 0.08,
        lichteWeite: 0,
        ecke: true,
      },
    ],
    json
  );
};

export const test10m: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [10]);
  agt.segmente[0].parts = [];
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  assertSegmentIstLückenlosGefüllt(s);
};

export const test3mMauerLinksSollDelta: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.segmente[0].parts = [];
  createMauer({ position: v3(-breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createDefaultElement();
  const delta = getIstSollZwischenabstandVerbose(s.empties[0], element);
  assert.deepEquals(
    {
      linksIst: {
        richtung: "Links",
        zwischenabstand: 0,
        gap: 0,
        umprofilBreite: 0,
        gapLinks: 0,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0,
        umprofilBreiteRechts: 0,
        gapRechts: 0,
        segmentEndenAusgleich: 0,
        eckadapterDelta: 0,
      },
      linksSoll: {
        richtung: "Links",
        zwischenabstand: 0.01,
        gap: -0.02,
        umprofilBreite: 0.03,
        gapLinks: 0,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0,
        umprofilBreiteRechts: 0.03,
        gapRechts: -0.02,
        segmentEndenAusgleich: 0,
        eckadapterDelta: 0,
      },
      rechtsIst: {
        richtung: "Rechts",
        zwischenabstand: 0,
        gap: 0,
        umprofilBreite: 0,
        gapLinks: 0,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0,
        umprofilBreiteRechts: 0,
        gapRechts: 0,
        segmentEndenAusgleich: 0,
        eckadapterDelta: 0,
      },
      rechtsSoll: {
        richtung: "Rechts",
        zwischenabstand: 0.02,
        gap: -0.02,
        umprofilBreite: 0,
        gapLinks: -0.02,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0.08,
        umprofilBreiteRechts: 0,
        gapRechts: 0,
        segmentEndenAusgleich: -0.04,
        eckadapterDelta: 0,
      },
    },
    delta
  );
};

export const test3mMauerRechtsSollDelta: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.segmente[0].parts = [];
  createMauer({ position: v3(breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createDefaultElement();
  const delta = getIstSollZwischenabstandVerbose(s.empties[0], element);
  assert.deepEquals(
    {
      linksIst: {
        richtung: "Links",
        zwischenabstand: 0,
        gap: 0,
        umprofilBreite: 0,
        gapLinks: 0,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0,
        umprofilBreiteRechts: 0,
        gapRechts: 0,
        segmentEndenAusgleich: 0,
        eckadapterDelta: 0,
      },
      linksSoll: {
        richtung: "Links",
        zwischenabstand: 0.02,
        gap: -0.02,
        umprofilBreite: 0,
        gapLinks: 0,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0.08,
        umprofilBreiteRechts: 0,
        gapRechts: -0.02,
        segmentEndenAusgleich: -0.04,
        eckadapterDelta: 0,
      },
      rechtsIst: {
        richtung: "Rechts",
        zwischenabstand: 0,
        gap: 0,
        umprofilBreite: 0,
        gapLinks: 0,
        umprofilBreiteLinks: 0,
        pfostenBreite: 0,
        umprofilBreiteRechts: 0,
        gapRechts: 0,
        segmentEndenAusgleich: 0,
        eckadapterDelta: 0,
      },
      rechtsSoll: {
        richtung: "Rechts",
        zwischenabstand: 0.01,
        gap: -0.02,
        umprofilBreite: 0.03,
        gapLinks: -0.02,
        umprofilBreiteLinks: 0.03,
        pfostenBreite: 0,
        umprofilBreiteRechts: 0,
        gapRechts: 0,
        segmentEndenAusgleich: 0,
        eckadapterDelta: 0,
      },
    },
    delta
  );
};

export const test3mMauerRechts: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.segmente[0].parts = [];
  createMauer({ position: v3(breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  assertSegmentIstLückenlosGefüllt(s);
  const parts = s.getPartsAndPfosten();
  const json = logParts(s, parts);
  assert.deepEquals(
    [
      {
        x0: -0.04,
        x1: 0.04,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 0,
        breite: 0.08,
        lichteWeite: 0,
        ecke: true,
      },
      {
        x0: 0.02,
        x1: 0.67,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 0.65,
        lichteWeite: 0.61,
        ecke: false,
      },
      {
        x0: 0.65,
        x1: 0.73,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 0.71,
        x1: 2.49,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.78,
        lichteWeite: 1.74,
        ecke: false,
      },
      {
        x0: 2.47,
        x1: 2.5,
        gapLinks: 0,
        gapRechts: 0,
        type: "UMProfil",
        snap: 1,
        breite: 0.03,
        lichteWeite: 0,
        ecke: false,
      },
    ],
    json
  );
};

export const test3mMauerLinks: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.segmente[0].parts = [];
  createMauer({ position: v3(-breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  assertSegmentIstLückenlosGefüllt(s);
  const parts = s.getPartsAndPfosten();
  const json = logParts(s, parts);
  assert.deepEquals(
    [
      {
        x0: 0.5,
        x1: 0.53,
        gapLinks: 0,
        gapRechts: 0,
        type: "UMProfil",
        snap: 1,
        breite: 0.03,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 0.51,
        x1: 1.16,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 0.65,
        lichteWeite: 0.61,
        ecke: false,
      },
      {
        x0: 1.14,
        x1: 1.22,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 1.2,
        x1: 2.98,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 1.78,
        lichteWeite: 1.74,
        ecke: false,
      },
      {
        x0: 2.96,
        x1: 3.04,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 0,
        breite: 0.08,
        lichteWeite: 0,
        ecke: true,
      },
    ],
    json
  );
};

export const test295mMauerLinksRechts: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.95;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.segmente[0].parts = [];
  createMauer({ position: v3(breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  createMauer({ position: v3(-breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  assertSegmentIstLückenlosGefüllt(s);
  const parts = s.getPartsAndPfosten();
  const json = logParts(s, parts);
  assert.deepEquals(
    [
      {
        x0: 0.5,
        x1: 0.53,
        gapLinks: 0,
        gapRechts: 0,
        type: "UMProfil",
        snap: 1,
        breite: 0.03,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 0.51,
        x1: 1.455,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 0.945,
        lichteWeite: 0.905,
        ecke: false,
      },
      {
        x0: 1.435,
        x1: 1.515,
        gapLinks: 0,
        gapRechts: 0,
        type: "Pfosten",
        snap: 1,
        breite: 0.08,
        lichteWeite: 0,
        ecke: false,
      },
      {
        x0: 1.495,
        x1: 2.44,
        gapLinks: -0.02,
        gapRechts: -0.02,
        type: "Element",
        snap: 1,
        breite: 0.945,
        lichteWeite: 0.905,
        ecke: false,
      },
      {
        x0: 2.42,
        x1: 2.45,
        gapLinks: 0,
        gapRechts: 0,
        type: "UMProfil",
        snap: 1,
        breite: 0.03,
        lichteWeite: 0,
        ecke: false,
      },
    ],
    json
  );
};

export const test3mMauerMitte: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  createMauer({ position: v3(0, 0, 0), size: v3(1, 2, 0.2) });
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  assertSegmentIstLückenlosGefüllt(agt.segmente[0]);
  assertSegmentIstLückenlosGefüllt(agt.segmente[1]);
};

export const test4mBis5mGrobMauerLinks: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  _.range(4, 5, 0.01).forEach((breite) => {
    agt.grundriss.setStandardForm("Strecke", [breite]);
    agt.aufbauten = [];
    createMauer({ position: v3(-breite / 2, 0, 0), size: v3(1, 2, 0.2) });
    const s = agt.segmente[0];
    s.parts = [];
    agt.fillIndividuellSegmentsWithElements();
    assertSegmentIstLückenlosGefüllt(s);
  });
};

export const test418cmMauerLinks: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 4.18 - 0.04;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.aufbauten = [];
  createMauer({ position: v3(-breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  const s = agt.segmente[0];
  s.parts = [];
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  assertSegmentIstLückenlosGefüllt(s);
};

export const test417cmMauerLinksAnzahl: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 4.17 - 0.04;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.aufbauten = [];
  createMauer({ position: v3(-breite / 2, 0, 0), size: v3(1, 2, 0.2) });
  const s = agt.segmente[0];
  s.parts = [];
  agt.update3d();
  const element = agt.createDefaultElement();
  const empty = agt.segmente[0].empties[0];
  const emptyBreite = empty.breite;
  const {
    anzahlGanzeElemente,
    restBreite,
    elementBreite,
    deltaLinks,
    deltaRechts,
    elementZwischenAbstand,
  } = getElementAnzahlDieInsEmptyPasst(element, empty);
  const breiteBerechnet =
    -deltaLinks + elementBreite + elementZwischenAbstand + elementBreite - deltaRechts;
  assert.equals(emptyBreite, breiteBerechnet);
  assert.equals(2, anzahlGanzeElemente);
  assert.equals(0, restBreite);
};

export const testÄndereFüllungUndFülleLeerraum: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [5]);
  agt.segmente[0].parts = [];
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  agt.update3d();
  _.last(s.getElemente()).uiRemove();
  agt.update3d();
  APP.arrangement.setSelectedObjects([_.last(s.getElemente())]);
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Sand");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
  });
  agt.update3d();
  const defaultElement = agt.createDefaultElement({
    füllungAuswahlwert: agt.füllungAuswahlwert,
  });
  const added = s.empties[0].fillWithElements(defaultElement, {
    allowMassElement: true,
    minimalOneElement: true,
  });
  agt.update3d();
  assertSegmentIstLückenlosGefüllt(s);
  added.forEach((element) => {
    assert.equals(füllungAuswahlwert, element.füllungAuswahlwert);
  });
};
